import React from 'react';

const LinkPreviewCard = ({ link }) => {
    const { title, description, image, url, domain, error } = link;

    if (error) {
        // Fallback for failed scrapes: simple text link styled nicely
        return (
            <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 12px',
                    backgroundColor: 'rgba(0,0,0,0.03)',
                    border: '1px solid rgba(0,0,0,0.1)',
                    borderRadius: '12px',
                    textDecoration: 'none',
                    color: 'inherit',
                    marginTop: '8px',
                    maxWidth: '300px',
                    fontSize: '13px'
                }}
            >
                <span style={{ marginRight: '8px', fontSize: '16px' }}>🔗</span>
                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {domain || url}
                </div>
            </a>
        );
    }

    return (
        <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="link-preview-card"
            style={{
                display: 'flex',
                flexDirection: 'row', // Horizontal layout
                width: '320px', // Wider to fit content side-by-side
                minWidth: '320px',
                height: '100px', // Fixed height
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                overflow: 'hidden',
                textDecoration: 'none',
                color: 'inherit',
                border: '1px solid rgba(0,0,0,0.08)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                cursor: 'pointer',
                marginRight: '12px',
                flexShrink: 0
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.08)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.04)';
            }}
        >
            {image && (
                <div
                    style={{
                        height: '100%',
                        width: '100px', // Square-ish aspect on the left
                        minWidth: '100px',
                        backgroundImage: `url(${image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundColor: '#f0f0f0',
                        borderRight: '1px solid rgba(0,0,0,0.05)'
                    }}
                />
            )}

            <div style={{ padding: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1, overflow: 'hidden' }}>
                <div
                    style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        marginBottom: '2px', // Reduced margin
                        color: '#1a1a1a',
                        display: '-webkit-box',
                        WebkitLineClamp: 1, // Limit title to 1 line to fit description
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        lineHeight: '1.3'
                    }}
                >
                    {title}
                </div>

                {description && (
                    <div
                        style={{
                            fontSize: '11px',
                            color: '#555',
                            marginBottom: '4px',
                            display: '-webkit-box',
                            WebkitLineClamp: 2, // 2 lines for description
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            lineHeight: '1.3'
                        }}
                    >
                        {description}
                    </div>
                )}

                <div
                    style={{
                        fontSize: '10px',
                        color: '#999',
                        marginTop: 'auto',
                        display: 'flex',
                        alignItems: 'center',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {domain}
                </div>
            </div>
        </a>
    );
};

export default LinkPreviewCard;
